import React from "react";
import { useEffect,useContext,useState } from "react";
import { useTranslation } from 'react-i18next'
import { Link } from "react-router-dom";
import { GlobalContext } from '../../GlobalContext';

function to12Hour(time24) {
  if (typeof time24 !== 'string') return null;
  const str = time24.trim();

  // Regex: hh:mm(:ss)?
  const match = str.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (!match) return null;

  let [, hh, mm, ss] = match;
  hh = parseInt(hh, 10);
  mm = mm.padStart(2, '0');
  ss = ss ? ss.padStart(2, '0') : null;

  if (hh < 0 || hh > 23) return null;

  const ampm = hh >= 12 ? 'PM' : 'AM';
  let hour12 = hh % 12;
  if (hour12 === 0) hour12 = 12;

  return ss ? `${hour12}:${mm}:${ss} ${ampm}` : `${hour12}:${mm} ${ampm}`;
}


const Hellosection = () => {

    const [cityId,setCityId] =  useState(0);
    const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const { t, i18n } = useTranslation();
  const [getallsession, setallsession] = useState(null);
       const [loading, setLoading] = useState(true);
        const [error, setError] = useState(null);
const [cityoptions, setOptionData] = useState([]);
    const { siteName } = useContext(GlobalContext);
    const { default_country } = useContext(GlobalContext);
    const { default_langage } = useContext(GlobalContext);
    let baseUrl = siteName.baseUrl;
    let defult_endpoint = siteName.training_endpoits;
    let webEndpoints = siteName.commonEndpoints;
  
    useEffect(() => {
  

      const fetchSession_dat = async () => {
        try {
          const response = await fetch(baseUrl + defult_endpoint + 'get/all/session/language?languageId='+default_langage+'&countryId='+default_country);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const allession_data = await response.json();

          let language_session = {};
          let currentlanuage = parseInt(localStorage.getItem('default_langage_code'));
          const allession = allession_data.map((session) => {
           
            for (let i = 0; i < session.languageDetailsList.length; i++) {
              
              language_session = {};
          
              if(session.languageDetailsList[i].languageId === currentlanuage){
                
                language_session = {
                  address:session.languageDetailsList[i].address,
                  cost:session.languageDetailsList[i].cost,
                  languageField:session.languageDetailsList[i].languageField,
                  sessionId:session.sessionId,
                  languageId:session.languageDetailsList[i].languageId,
                  sessionLanguageId:session.languageDetailsList[i].sessionLanguageId,
                  title:session.languageDetailsList[i].title,
                  fromDate:session.fromDate,
                  toDate:session.toDate,
                  startTime:to12Hour(session.startTime),
                  endTime:to12Hour(session.endTime),
                  countryDetails:session.countryDetails,
                  cityDetails:session.cityDetails,
                  languageField_id:session.languageField,
                }
              }
            }
            if (Object.keys(language_session).length === 0) {
              language_session = {
                address:session.address,
                cost:session.cost,
                languageField:session.languageField,
                sessionId:session.sessionId,
                languageId:1,
                sessionLanguageId:null,
                title:session.title,
                fromDate:session.fromDate,
                toDate:session.toDate,
                countryDetails:session.countryDetails,
                languageField_id:session.languageField,
                cityDetails:session.cityDetails,
              }
            }
            const item = {
              session_data:session,
              language_session_data:language_session
              
            };
            return item;
          });
          console.log(allession);
          setallsession(allession)
        } catch (error) {
          setError(error);
          setLoading(false);
        }
      };
    
      fetchSession_dat();
    }, []);

    useEffect(() => {
      const fetchCountries = async () => {
        try {
          const response = await fetch(baseUrl + webEndpoints + 'get/all/countries');
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const countries = await response.json();
    
          let cities = '';
          countries.map((country) => {
            if(country.countryId == default_country){
              cities = country.cities;
            }
              
          });
          setOptionData(cities);

          setLoading(false);
        } catch (error) {
          setError(error);
          setLoading(false);
        }
      };
    
      fetchCountries();
    }, []);


    if (loading) console.log(loading);
    if (error) console.log(error);

    const date_convet_data = (date) => {
      let date_object = new Date(date);
      return  date_object.toLocaleDateString("en-US", {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    }
    const session_data_udate = (e) =>{
      console.log(e.target.getAttribute("data-id"));
      sessionStorage.setItem('session_id',e.target.getAttribute("data-id"))
    };
     const handleChange = (event) => {
    const value = event.target.value;
    setCityId(value);
  };

  return (
    <div className="event-content">

       { cityoptions != 0 ?  <div><label>{t("select_city")}</label><select name="city" onChange={handleChange}  ><option value="">{t("select_city")}</option>{cityoptions.map((city,index) => (
                 <option value={city.cityId}>{city.cityName}</option>))} </select></div> : '' }
    <div className="accordion" id={'accordion-traning-session'}>
            { getallsession == null? (<div className="accordion-body no-data-found">
              No data found
    </div>) : (  getallsession.map((data, index) => (
            [ data.language_session_data.cityDetails != null && data.language_session_data.cityDetails.cityId == cityId? 
        <div className="accordion-item" eventKey={index}>
          <h2 className="accordion-header">
            <button className={`accordion-button ${openIndex === index ? '' : ''}`} type="button" data-bs-toggle="collapse" data-bs-target={'#collapse-'+index} aria-expanded="false" aria-controls={'collapse-'+index} onClick={() => toggle(index)}>
                <span><img src="img/session-icon.svg" alt=""/></span>{data.language_session_data.title}
            </button>
          </h2>
          <div id={'collapse-'+index} className={`accordion-collapse collapse ${openIndex === index ? '' : ''}`} data-bs-parent={'accordion-traning-session'}>
            <div key={index} className="accordion-body">
        <div className="event-info">
          
            <h3>{t("when")}:</h3>
            <p>{date_convet_data(data.language_session_data.fromDate)} {data.language_session_data.startTime} – {date_convet_data(data.language_session_data.toDate)} {data.language_session_data.endTime}</p>
            <h3>{t("where")}:</h3>
            <p>{data.language_session_data.address}</p>
            <h3>{t("language")}:</h3>
            <p>{data.language_session_data.languageField_id}</p>
            {data.language_session_data.cityDetails != null? <>
            
             <h3>{t("city")}:</h3>
            <p>{data.language_session_data.cityDetails != null? data.language_session_data.cityDetails.cityName:''}</p>
            </>:''
         }
        </div>
        <div className="event-cost">
            <h3>{t("cost")}:</h3>
            <p>{data.language_session_data.cost}</p>
            <p>({t("a_residential_component_will_not_be_offer_we_advise_you_to_book_rooms_in_hotels_and_airbnbs_close_by")})</p>
            <div className="cfn-login-btn">
                <li><Link data-bs-toggle="modal" data-id={data.language_session_data.sessionId} onClick={session_data_udate} data-bs-target="#studentModal" className="cfn-global-btn">{t("register")}</Link></li>
            </div>
        </div>
    </div> </div>
        </div> : cityId == 0? <div className="accordion-item" eventKey={index}>
          <h2 className="accordion-header">
            <button className={`accordion-button ${openIndex === index ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target={'#collapse-'+index} aria-expanded="false" aria-controls={'collapse-'+index} onClick={() => toggle(index)}>
                <span><img src="img/session-icon.svg" alt=""/></span><span className="session-title">{data.language_session_data.title}</span>
            </button>
          </h2>
          <div id={'collapse-'+index} className={`accordion-collapse collapse ${openIndex === index ? '' : ''}`} data-bs-parent={'accordion-traning-session'}>
            <div key={index} className="accordion-body">
        <div className="event-info">
          
            <h3>{t("when")}:</h3>
            <p>{date_convet_data(data.language_session_data.fromDate)} {data.language_session_data.startTime} – {date_convet_data(data.language_session_data.toDate)} {data.language_session_data.endTime}</p>
            <h3>{t("where")}:</h3>
            <p>{data.language_session_data.address}</p>
            <h3>{t("language")}:</h3>
            <p>{data.language_session_data.languageField_id}</p>
            {data.language_session_data.cityDetails != null? <>
            
             <h3>{t("city")}:</h3>
            <p>{data.language_session_data.cityDetails != null? data.language_session_data.cityDetails.cityName:''}</p>
            </>:''}
        </div>
        <div className="event-cost">
            <h3>{t("cost")}:</h3>
            <p>{data.language_session_data.cost}</p>
            <p>({t("a_residential_component_will_not_be_offer_we_advise_you_to_book_rooms_in_hotels_and_airbnbs_close_by")})</p>
            <div className="cfn-login-btn">
                <li><Link data-bs-toggle="modal" data-id={data.language_session_data.sessionId} onClick={session_data_udate} data-bs-target="#studentModal" className="cfn-global-btn">{t("register")}</Link></li>
            </div>
        </div>
    </div> </div>
        </div> : '']
     )
      )
    ) 
            }
          </div>
</div>
  );
};

export default Hellosection;